import * as React from 'react';

import classNames from 'classnames';
import { IJkSchema } from '../../repositories/special-promos/entities/entities/JkSchema';

import { JkListItem } from '../jk-list-item';

import * as styles from './index.css';

const SHORT_LIST_ELEMENT_COUNT = 12;

interface IJkListProps {
  jks: IJkSchema[];
}

interface IJkListState {
  showFullList: boolean;
}

export class JkList extends React.Component<IJkListProps, IJkListState> {
  public constructor(props: IJkListProps) {
    super(props);

    this.state = {
      showFullList: props.jks.length <= SHORT_LIST_ELEMENT_COUNT,
    };
  }

  public render() {
    const { showFullList } = this.state;

    return (
      <div>
        <div className={styles['jk-list']}>
          {this.getJkList().map((jk, idx) => (
            <JkListItem jk={jk} key={idx} />
          ))}
        </div>
        {!showFullList && (
          <div className={styles['pagination']}>
            <button className={classNames(styles['load-more'], 'iefix_transparent_button')} onClick={this.showMore}>
              Показать ещё
            </button>
          </div>
        )}
      </div>
    );
  }

  private showMore = () => {
    this.setState({
      showFullList: true,
    });
  };

  private getJkList() {
    const { jks } = this.props;

    if (this.state.showFullList) {
      return jks;
    }

    return jks.slice(0, SHORT_LIST_ELEMENT_COUNT);
  }
}
